<template>
  <div class="d-flex justify-content-between align-items-center">
    <ArchivedLabel hide-archived-text :disabled="!accountingClass.archived">
      <span>{{ accountingClass.name }}</span>
    </ArchivedLabel>
    <div v-if="!finalized">
      <i class="fas fa-edit ml-1 link" @click="toggleModal"></i>
      <InvoiceAccountingClassModal
        v-if="modalOpen"
        :invoice-id="invoiceId"
        :accounting-class-id="classId"
        @hide-modal="toggleModal"
        @save-success="refreshDatatable"
      />
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import ArchivedLabel from "@/components/ArchivedLabel.vue";
import InvoiceAccountingClassModal from "@/Reports/InvoiceAccountingClassModal.vue";
export default {
  components: {
    ArchivedLabel,
    InvoiceAccountingClassModal
  },
  props: {
    invoiceId: {
      type: Number,
      default: null
    },
    accountingClass: {
      type: Object,
      default: null
    },
    finalized: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalOpen: false
    };
  },
  computed: {
    classId() {
      return this.accountingClass ? this.accountingClass.id : null;
    }
  },
  methods: {
    refreshDatatable() {
      EventBus.$emit("refresh-datatable");
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    }
  }
};
</script>

<style lang="scss" scoped></style>
